import { render, staticRenderFns } from "./terms-july.vue?vue&type=template&id=12a8174c&scoped=true&"
import script from "./terms-july.vue?vue&type=script&lang=js&"
export * from "./terms-july.vue?vue&type=script&lang=js&"
import style0 from "./terms-july.vue?vue&type=style&index=0&id=12a8174c&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a8174c",
  null
  
)

export default component.exports